module.exports = __webpack_public_path__ + "static/media/deleteTrash24.9022f869.svg";